module.exports = {
  "wxc-tag": {
    "alignItems": "flex-start"
  },
  "tag-item": {
    "height": 24,
    "justifyContent": "center",
    "alignItems": "center",
    "overflow": "hidden",
    "paddingBottom": 2
  },
  "tag-border": {
    "borderBottomLeftRadius": 4,
    "borderBottomRightRadius": 4,
    "borderTopLeftRadius": 4,
    "borderTopRightRadius": 4
  },
  "tag-hollow": {
    "borderWidth": 1
  },
  "tag-image": {
    "height": 24
  },
  "tag-special": {
    "borderWidth": 1,
    "flexDirection": "row"
  },
  "left-image": {
    "width": 20,
    "height": 20
  },
  "tag-left": {
    "width": 24,
    "height": 24,
    "alignItems": "center",
    "justifyContent": "center"
  },
  "tag-text": {
    "fontSize": 20,
    "height": 22,
    "lineHeight": 22,
    "paddingLeft": 6,
    "paddingRight": 6
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7266651e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-tag/index.vue
// module id = 146
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28